import React from 'react';
import PropTypes from 'prop-types';

const AccommodationLabel = props => (
  <label className={`text-white crown-holder font-weight-bold ${props.classNames}`}>
    <div className="crown">
      <img src={props.source} />
      {props.text}
    </div>
  </label>
);

AccommodationLabel.propTypes = {
  classNames: PropTypes.string,
  source: PropTypes.string,
  text: PropTypes.string,
};

export default AccommodationLabel;
